<div *ngIf="loading | async;">
  <mat-spinner class="global-spinner" data-testid="modal-panel-loading-spinner"></mat-spinner>
</div>
<form *ngIf="!(loading | async)" [formGroup]="navUploadForm" id="file-upload-nav-upload-form" class="template-form">
    <div id="file-upload-row" layout="row">
      <mat-form-field id="file-upload-form-field" [hideRequiredMarker]="true">
        <mat-label id="file-upload-label">Trams Branch Group</mat-label>
        <mat-select id="file-upload-select" matInput name="dataSource" [formControl]="dataSourceFormControl" (selectionChange)="onDataSourceSelected()" [errorStateMatcher]="dataSourceErrorStateMatcher" [(ngModel)]="NavBranchId" required>
          <mat-option id="file-upload-option-{{i}}" *ngFor="let item of datasources; let i = index" [value]="item.id">
            {{ item.branchName }}
          </mat-option>
        </mat-select>
        <mat-error id="file-upload-error" *ngIf="dataSourceFormControl.hasError('min')">Data Source is required</mat-error>
      </mat-form-field>
    </div>
    <div id="file-upload-row" layout="row">
      <div id="file-upload-center" class="center"><h3>Upload files for Nav report</h3></div>
      <br />
      <div flex="">
        <div flex="">
          <label id="file-upload-file1-label" for="file1Input">Previous period</label>
        </div>
        <input id="file-upload-file1-input" class="form-control" type="file" (change)="onFileSelected($event, 'file1')" [formControl]="file1FormControl" required>
        <mat-error id="file-upload-file1-error" *ngIf="file1 && file1FormControl.hasError('required')">File is required</mat-error>
      </div>
      <br />
      <div flex="">
        <div flex="">
          <label id="file-upload-file2-label" for="file2Input">Current period</label>
        </div>
        <input id="file-upload-file2-input" class="form-control" type="file" (change)="onFileSelected($event, 'file2')" [formControl]="file2FormControl" required>
        <mat-error id="file-upload-file2-Error" *ngIf="file2 && file2FormControl.hasError('required')">File is required</mat-error>
      </div>
      <br />
      <div flex="">
        <button id="file-upload-upload-button" mat-flat-button color="primary" (click)="uploadNavReportFiles()" class="btn btn-success" [disabled]="!file1 || !file2 || dataSourceFormControl.invalid"> Upload </button>
      </div>
    </div>
    <br />
    <div flex="">
      <button id="file-upload-downloadButton" mat-flat-button color="primary" (click)="onReportDownload()" class="btn btn-success" [disabled]="dataSourceFormControl.invalid"> Download current report </button>
      <mat-error id="file-upload-downloadError" *ngIf="IsEmptyNavReportData && !dataSourceFormControl.hasError('min')">No data found</mat-error>
    </div>
    <br />
    <hr />
    <br />
    <div id="file-upload-row" layout="row">
      <div id="file-upload-center" class="center"><h3>Update mappings</h3></div>
      <div id="file-upload-flex1" flex="">
        <label id="file-upload-label" for="file1Input">Nav Mapping by selected Trams Branch Group</label>
      </div>
      <br />
      <div flex="">
        <button id="file-upload-download-button" mat-flat-button color="primary" (click)="onMappingDownload()" class="btn btn-success" [disabled]="dataSourceFormControl.invalid"> Download current mapping </button>
        <mat-error id="file-upload-error" *ngIf="IsEmptyNavMappingData">No data found</mat-error>
      </div>
      <br />
      <div flex="">
        <input id="file-upload-file-mapping-input" class="form-control" type="file" (change)="onFileSelected($event, 'file3')" [formControl]="fileMappingFormControl" required>
        <mat-error id="file-upload-file-error" *ngIf="file3 && fileMappingFormControl.hasError('required')">File is required</mat-error>
      </div>
      <br />
      <div flex="">
        <button id="file-upload-upload-button" mat-flat-button color="primary" (click)="uploadNavMappingFile()" class="btn btn-success" [disabled]="!file3 || dataSourceFormControl.invalid"> Upload </button>
      </div>
    </div>
</form>